import {mergeDeep} from "../../../utils/Helper";
import {validationsContact} from "../CustodianEntity/CustodianEntityContact";
import {validationsClearingHouse} from "../CustodianEntity/CustodianEntityClearingHouse";
import {validationsCustodianEntity} from "../CustodianEntity/CustodianEntity";
import { validationsCodeTypes } from "../CustodianEntity/CustodianEntityCodeType";

export const defaultStateEntity = () => ({
  custodian: {
    CustodianEntityId: 0,
    CustodianEntityName: "",
    LegalInstitutionCode: "",
    CountryId: 0,
    CountryName: "",
    CustodianEntityLogo: "",
    CustodianEntityFileType: "",
    CustodianEntityAddress: "",
    CustodianEntityTAXId: "",
    CustodianEntityTaxDocument: "",
    CustodianEntityURL: "",
    CustodianEntityIntroducedBy: "",
    CustodianEntitySwift: "",
    CustodianEntityNotes: "",
    CustodianEntityPendingLimit: 0,
    CustodianEntityIsExchangeListed: false,
    CustodianEntityHasInvestmentGrade: false,
    CustodianEntityIsBank: false,
    LegalCustodianCode: "",
    CustodianEntityReference:"",
    countries: [],
    taxDocument: [],
    Contact: [],
    ClearingHouse: [],
    CodeType: []
  },
  custodianContact: {
    CustodianEntityContactName: "",
    CustodianEntityContactEmail1: "",
    CustodianEntityContactEmail2: "",
    CustodianEntityContactTel1: "",
    CustodianEntityContactTel2: "",
    CustodianEntityContactType: "",
    contactTypes: [],
    CustodianEntityContactNotes: "",
    CustodianEntityContactTicketConfirmation: false,
    CustodianEntityContactChangeType: ""
  },
  custodianClearingHouse: {
    CustodyClearingHouseCode: "",
    ClearingHouseId: "",
    clearingHouseName: "",
    clearingHouseNames: [],
    CustodyClearingHouseIsDefault: false,
    CustodyClearingHouseSettlementInstructions: "",
    CustodianEntityClearingHouseStatus: "Active",
    CustodianEntityClearingHouseCodeChange: "",
    CustodyClearingHouseChangeType: ""
  },
  custodianCodeType: {
    CodeTypeId: 0,
    CodeTypeValue: "",
    CodeTypeChangeType: ""
  },
  fields: {
    readonly: {},
    errors: {}
  },
  loadingConfirmCustodianEntity: false,
  messageConfirmCustodianEntity: false,
  error: true,
  errors: {},
  EditClearingHouse: false,
  IndexEditClearingHouse: 0,
  EditCodeType: false,
  IndexEditCodeType: 0,
  EditContact: false,
  IndexEditContact: 0,
  openCustodianEntity: false,
  openCustodianEntityContact: false,
  openCustodianEntityClearingHouse: false,
  openCustodianEntityCodeType: false
});

export const CustodianEntityReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_FIELDS":
      return processChangeFields(state, action.fields);
    case "SET_COUNTRIES":
      return SetCountries(state, action);
    case "UPDATE_FIELDS":
      return processFields(state, action.fields);
    case "SET_TAX_DOCUMENT":
      return SetTaxDocument(state, action);
    case "SET_CUSTODIAN_CONTACT_TYPE":
      return SetCustodianContactType(state, action);
    case "SET_CUSTODIAN_CLEARING_HOUSE":
      return SetCustodianClearingHouse(state, action);
    case "SET_CUSTODIAN_CODE_TYPE":
      return SetCustodianCodeType(state, action);
    case "SET_ENTITY_CONTACT":
      return processChangeContactFields(state, action.fields);
    case "SET_CLEARING_HOUSE":
      return processChangeClearingHouse(state, action.fields);
    case "SET_CODE_TYPE":
      return processChangeCodeType(state, action.fields);
    case "UPDATE_VALIDATION_CONTACT_FORM":
      return forceUpdateValidationContact(state, action);
    case "UPDATE_VALIDATION_CODE_FORM":
      return forceUpdateValidationContact(state, action);
    case "SET_CONTACT":
      return SetContact(state, action);
    case "SET_CLEARING_HOUSE_FORM":
      return SetClearingHouse(state, action);
    case "SET_CODE_TYPE_FORM":
        return SetCodeType(state, action);
    case "GET_CLEARING_HOUSE":
      return GetClearingHouse(state, action);
    case "GET_CODE_TYPE":
        return GetCodeType(state, action);
    case "UPDATE_CLEARING_HOUSE":
      return UpdateClearingHouse(state, action);
    case "UPDATE_CODE_TYPE":
      return UpdateCodeType(state, action);
    case "DELETE_CLEARING_HOUSE":
      return DeleteClearingHouse(state, action);
    case "DELETE_CODE_TYPE":
      return DeleteCodeType(state, action);
    case "GET_CONTACT":
      return GetContact(state, action);
    case "UPDATE_CONTACT":
      return UpdateContact(state, action);
    case "DELETE_CONTACT":
      return DeleteContact(state, action);
    case "RESET_CLEARING_HOUSE":
      return resetClearingHouse(state, action);
    case "RESET_CODE_TYPE":
      return resetCodeType(state, action);
    case "RESET_CONTACT":
      return resetContact(state, action);
    case "GET_CUSTODIAN_ENTITY":
      return getCustodianEntity(state, action);
    case "RESET_CUSTODIAN_ENTITY":
      return resetCustodianEntity(state, action);
    default:
      return state;
  }
};

export const initializeCustodianEntity = props => {
  return initialState => {
    return {
      ...initialState
    };
  };
};

function processChangeFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});

  return mergeDeep(
    {...state},
    {
      custodian: {
        ...fields
      },
      fields: {
        errors
      }
    }
  );
}

function processFields(state, fields) {
  return mergeDeep(
    {...state},
    {
      ...fields
    }
  );
}

export function SetCountries(state, action) {
  var countryId = 0;
  var countryName = "";
  if (action.response.countries.length > 0) {
    countryId = action.response.countries[0].id;
    countryName = action.response.countries[0].name;
  }
  return mergeDeep(
    {...state},
    {
      custodian: {
        countries: action.response.countries,
        CountryId: countryId,
        CountryName: countryName
      }
    }
  );
}

export function SetTaxDocument(state, action) {
  var taxId = "";
  if (action.response.taxDocument.length > 0) {
    taxId = action.response.taxDocument[0];
  }
  return mergeDeep(
    {...state},
    {
      custodian: {
        taxDocument: action.response.taxDocument,
        CustodianEntityTaxDocument: taxId
      }
    }
  );
}

export function SetCustodianContactType(state, action) {
  var contactType = "";
  if (action.response.custodianType.length > 0) {
    contactType = action.response.custodianType[0];
  }
  return mergeDeep(
    {...state},
    {
      custodianContact: {
        contactTypes: action.response.custodianType,
        CustodianEntityContactType: contactType
      }
    }
  );
}

export function SetCustodianClearingHouse(state, action) {
  var clearingHouse = "";
  var clearingHouseName = "";
  if (action.response.clearingHouses.length > 0) {
    clearingHouse = action.response.clearingHouses[0].id;
    clearingHouseName = action.response.clearingHouses[0].name;
  }
  return mergeDeep(
    {...state},
    {
      custodianClearingHouse: {
        clearingHouseNames: action.response.clearingHouses,
        ClearingHouseId: clearingHouse,
        clearingHouseName: clearingHouseName
      }
    }
  );
}

export function SetCustodianCodeType(state, action) {
  var CodeType = "";
  var CodeTypeName = "";
  if (action.response.CodeTypes.length > 0) {
    CodeType = action.response.CodeTypes[0].CodeTypeId;
    CodeTypeName = action.response.CodeTypes[0].CodeTypeName;
  }
  return mergeDeep(
    {...state},
    {
      CodeTypeNames: action.response.CodeTypes,
      custodianCodeType: {
        CodeTypeId: CodeType,
        CodeTypeName: CodeTypeName
      }
    }
  );
}

function processChangeContactFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});
  return mergeDeep(
    {...state},
    {
      custodianContact: {
        ...fields
      },
      fields: {
        errors
      }
    }
  );
}

function processChangeClearingHouse(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});
  return mergeDeep(
    {...state},
    {
      custodianClearingHouse: {
        ...fields
      },
      fields: {
        errors
      }
    }
  );
}

function processChangeCodeType(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});
  return mergeDeep(
    {...state},
    {
      custodianCodeType: {
        ...fields
      },
      fields: {
        errors
      }
    }
  );
}

export function ValidateContactForm(state) {
  const {custodianContact, fields} = state;

  const errors = {};

  Object.entries(validationsContact(custodianContact)).forEach(entry => {
    const [name, value] = entry;

    if (value.empty) {
      if (
        custodianContact[name] == undefined ||
        custodianContact[name] === ""
      ) {
        errors[name] = "Required field";
      }
      // else if (value.autosuggestId && custodianContact[value.autosuggestId] == undefined) {
      //   errors[name] = 'Must select a value from list'
    }
  });

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}

export function ValidateClearingHouse(state) {
  const {custodianClearingHouse, fields} = state;

  const errors = {};

  Object.entries(validationsClearingHouse(custodianClearingHouse)).forEach(
    entry => {
      const [name, value] = entry;

      if (value.empty) {
        if (
          custodianClearingHouse[name] == undefined ||
          custodianClearingHouse[name] === ""
        ) {
          errors[name] = "Required field";
        }
        // else if (value.autosuggestId && custodianContact[value.autosuggestId] == undefined) {
        //   errors[name] = 'Must select a value from list'
      }
    }
  );

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}

export function ValidateCodeTypes(state, CodeTypes, EditCodeType) {
  const {custodianCodeType} = state;
  const errors = {};

  Object.entries(validationsCodeTypes(custodianCodeType)).forEach(
    entry => {
      const [name, value] = entry;

      if (value.empty) {
        if (
          custodianCodeType[name] == undefined ||
          custodianCodeType[name] === ""
        ) {
          errors[name] = "Required field";
        }
      }
    }
  );
  if (!EditCodeType && CodeTypes.some(e => e.CodeTypeChangeType !== "Delete" && e.CodeTypeId == custodianCodeType.CodeTypeId)){
      errors.unique = "Code Type must be unique."
  }

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}

export function ValidateCustodianEntity(state) {
  const {custodian, fields} = state;

  const errors = {};

  Object.entries(validationsCustodianEntity(custodian)).forEach(entry => {
    const [name, value] = entry;

    if (value.empty) {
      if (custodian[name] == undefined || custodian[name] === "") {
        errors[name] = "Required field";
      }
      if (name == "CountryId" && custodian.CountryId <= 0)
        errors.CountryId = "Required field";
      // else if (value.autosuggestId && custodianContact[value.autosuggestId] == undefined) {
      //   errors[name] = 'Must select a value from list'
    }
  });

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}

export function forceUpdateValidationContact(state, {errors}) {
  return {
    ...state,
    errors: errors
  };
}

export function SetContact(state, action) {
  return {
    ...state,
    custodian: {
      ...state.custodian,
      Contact: [...state.custodian.Contact, action.action.custodianContact]
    }
  };
}

export function SetClearingHouse(state, action) {
  action.action.custodianClearingHouse.CustodyClearingHouseChangeType = "New";
  return {
    ...state,
    custodian: {
      ...state.custodian,
      ClearingHouse: [
        ...state.custodian.ClearingHouse,
        action.action.custodianClearingHouse
      ]
    }
  };
}

export function SetCodeType(state, action) {
  action.action.custodianCodeType.CodeTypeChangeType = "New";
  return {
    ...state,
    custodian: {
      ...state.custodian,
      CodeType: [
        ...state.custodian.CodeType,
        action.action.custodianCodeType
      ]
    }
  };
}
export function GetClearingHouse(state, action) {
  return {
    ...state,
    custodianClearingHouse: {
      ...state.custodianClearingHouse,
      CustodyClearingHouseCode: action.e.CustodyClearingHouseCode,
      ClearingHouseId: action.e.ClearingHouseId,
      clearingHouseName: action.e.clearingHouseName,
      CustodyClearingHouseIsDefault: action.e.CustodyClearingHouseIsDefault,
      CustodyClearingHouseSettlementInstructions:
        action.e.CustodyClearingHouseSettlementInstructions,
      CustodianEntityClearingHouseStatus:
        action.e.CustodianEntityClearingHouseStatus,
      CustodianEntityClearingHouseCodeChange:
        action.e.CustodianEntityClearingHouseCodeChange,
      CustodyClearingHouseChangeType: action.e.CustodyClearingHouseChangeType
    }
  };
}

export function GetCodeType(state, action) {
  return {
    ...state,
    custodianCodeType: {
      ...state.custodianCodeType,
      CodeTypeId: action.e.CodeTypeId,
      OldCodeTypeId: action.e.CodeTypeId,

      CodeTypeName: action.e.CodeTypeName,
      OldCodeTypeName: action.e.CodeTypeName,

      CodeTypeValue: action.e.CodeTypeValue
    }
  };
}


export function UpdateClearingHouse(state, action) {
  var lastClearingHouseCode = "";
  var ClearingHouses = state.custodian.ClearingHouse;
  lastClearingHouseCode =
    ClearingHouses[state.IndexEditClearingHouse].CustodyClearingHouseCode;
  ClearingHouses[state.IndexEditClearingHouse] =
    action.action.custodianClearingHouse;
  ClearingHouses[
    state.IndexEditClearingHouse
  ].CustodianEntityClearingHouseCodeChange = lastClearingHouseCode;
  action.action.custodianClearingHouse;
  ClearingHouses[state.IndexEditClearingHouse].CustodyClearingHouseChangeType =
    "Edit";
  return {
    ...state,
    custodian: {
      ...state.custodian,
      ClearingHouse: ClearingHouses
    }
  };
}

export function UpdateCodeType(state, action) {
  var lastCodeId = "";
  var CodeTypes = state.custodian.CodeType;
  lastCodeId = CodeTypes[state.IndexEditCodeType].CodeTypeId;
  CodeTypes[state.IndexEditCodeType] = action.action.custodianCodeType;
  CodeTypes[state.IndexEditCodeType].CustodianEntityCodeTypeChange = lastCodeId;
  action.action.custodianCodeType;
  CodeTypes[state.IndexEditCodeType].CustodyCodeTypeChangeType =
    "Edit";
  return {
    ...state,
    custodian: {
      ...state.custodian,
      CodeType: CodeTypes
    }
  };
}

export function DeleteClearingHouse(state, action) {
  var CustodianClearingHouses = state.custodian.ClearingHouse;
  CustodianClearingHouses[action.action].CustodyClearingHouseChangeType =
    "Delete";

  return {
    ...state,
    custodian: {
      ...state.custodian,
      ClearingHouse: CustodianClearingHouses
    }
  };
}

export function DeleteCodeType(state, action) {
  var CustodianCodeTypes = state.custodian.CodeType;
  CustodianCodeTypes[action.action].CodeTypeChangeType =
    "Delete";
  CustodianCodeTypes[action.action].CodeTypeDelete = true;

  return {
    ...state,
    custodian: {
      ...state.custodian,
      CodeType: CustodianCodeTypes,
      CodeTypeChangeType: ""
    }
  };
}

export function GetContact(state, action) {
  return {
    ...state,
    custodianContact: {
      ...state.custodianContact,
      CustodianEntityContactName: action.e.CustodianEntityContactName,
      CustodianEntityContactEmail1: action.e.CustodianEntityContactEmail1,
      CustodianEntityContactEmail2: action.e.CustodianEntityContactEmail2,
      CustodianEntityContactTel1: action.e.CustodianEntityContactTel1,
      CustodianEntityContactTel2: action.e.CustodianEntityContactTel2,
      CustodianEntityContactType: action.e.CustodianEntityContactType,
      CustodianEntityContactNotes: action.e.CustodianEntityContactNotes,
      CustodianEntityContactTicketConfirmation:
        action.e.CustodianEntityContactTicketConfirmation,
      CustodianEntityContactChangeType:
        action.e.CustodianEntityContactChangeType
    }
  };
}

export function UpdateContact(state, action) {
  var Contacts = state.custodian.Contact;
  Contacts[state.IndexEditContact] = action.action.custodianContact;
  return {
    ...state,
    custodian: {
      ...state.custodian,
      Contact: Contacts
    }
  };
}

export function DeleteContact(state, action) {
  var CustodianContacts = [];
  CustodianContacts = state.custodian.Contact.splice(action.action, 1);
  return {
    ...state,
    custodian: {
      ...state.custodian,
      Contact: state.custodian.Contact
    }
  };
}

export function resetClearingHouse(state, action) {
  var clearingHouse = "";
  var clearingHouseName = "";
  if (state.custodianClearingHouse.clearingHouseNames.length > 0) {
    clearingHouse = state.custodianClearingHouse.clearingHouseNames[0].id;
    clearingHouseName = state.custodianClearingHouse.clearingHouseNames[0].name;
  }
  return {
    ...state,
    custodianClearingHouse: {
      ...state.custodianClearingHouse,
      CustodyClearingHouseCode: "",
      ClearingHouseId: clearingHouse,
      clearingHouseName: clearingHouseName,
      CustodyClearingHouseIsDefault: false,
      CustodyClearingHouseSettlementInstructions: "",
      CustodianEntityClearingHouseStatus: "Active",
      CustodianEntityClearingHouseCodeChange: "",
      CustodyClearingHouseChangeType: ""
    }
  };
}

export function resetCodeType(state, action) {
  var CodeTypeId = "";
  var CodeTypeName = "";
  if (state.CodeTypeNames.length > 0) {
    CodeTypeId = state.CodeTypeNames[0].CodeTypeId;
    CodeTypeName = state.CodeTypeNames[0].CodeTypeName;
  }
  return {
    ...state,
    custodianCodeType: {
      ...state.custodianCodeType,
      CodeTypeId: CodeTypeId,
      CodeTypeName: CodeTypeName,
      CodeTypeValue: "",
      CodeTypeChangeType: ""
    }
  };
}

export function resetContact(state, action) {
  var contactType = "";
  if (state.custodianContact.contactTypes.length > 0) {
    contactType = state.custodianContact.contactTypes[0];
  }
  return {
    ...state,
    custodianContact: {
      ...state.custodianContact,
      CustodianEntityContactName: "",
      CustodianEntityContactEmail1: "",
      CustodianEntityContactEmail2: "",
      CustodianEntityContactTel1: "",
      CustodianEntityContactTel2: "",
      CustodianEntityContactType: contactType,
      CustodianEntityContactNotes: "",
      CustodianEntityContactTicketConfirmation: false
    }
  };
}

export function getCustodianEntity(state, action) {
  var contacts = [];
  var clearingHouses = [];
  var codeTypes = [];
  if (action.response.custodianEntity.Contact !== undefined) {
    contacts = action.response.custodianEntity.Contact;
  }
  if (action.response.custodianEntity.ClearingHouse !== undefined) {
    clearingHouses = action.response.custodianEntity.ClearingHouse;
  }
  if (action.response.custodianEntity.CodeType !== undefined) {
    codeTypes = action.response.custodianEntity.CodeType;
  }
  return {
    ...state,
    custodian: {
      ...state.custodian,
      CustodianEntityId: 0,
      CustodianEntityName: action.response.custodianEntity.CustodianEntityName,
      LegalInstitutionCode:
        action.response.custodianEntity.LegalInstitutionCode,
      CountryId: action.response.custodianEntity.CountryId,
      CountryName: action.response.custodianEntity.CountryName,
      CustodianEntityLogo: action.response.custodianEntity.CustodianEntityLogo,
      CustodianEntityFileType:
        action.response.custodianEntity.CustodianEntityFileType,
      CustodianEntityAddress:
        action.response.custodianEntity.CustodianEntityAddress,
      CustodianEntityTAXId:
        action.response.custodianEntity.CustodianEntityTAXId,
      CustodianEntityTaxDocument:
        action.response.custodianEntity.CustodianEntityTaxDocument,
      CustodianEntityURL: action.response.custodianEntity.CustodianEntityURL,
      CustodianEntityIntroducedBy:
        action.response.custodianEntity.CustodianEntityIntroducedBy,
      CustodianEntitySwift:
        action.response.custodianEntity.CustodianEntitySwift,
      CustodianEntityNotes:
        action.response.custodianEntity.CustodianEntityNotes,
      CustodianEntityPendingLimit:
        action.response.custodianEntity.CustodianEntityPendingLimit,
      CustodianEntityIsExchangeListed:
        action.response.custodianEntity.CustodianEntityIsExchangeListed,
      CustodianEntityHasInvestmentGrade:
        action.response.custodianEntity.CustodianEntityHasInvestmentGrade,
      CustodianEntityIsBank:
        action.response.custodianEntity.CustodianEntityIsBank,
      LegalCustodianCode: action.response.custodianEntity.LegalCustodianCode,
      CustodianEntityReference:action.response.custodianEntity.CustodianEntityReference,
      Contact: contacts,
      ClearingHouse: clearingHouses,
      CodeType: codeTypes
    }
  };
}

export function resetCustodianEntity(state, action) {
  return {
    ...state,
    custodian: {
      CustodianEntityId: 0,
      CustodianEntityName: "",
      LegalInstitutionCode: "",
      CountryId: 0,
      CountryName: "",
      CustodianEntityLogo: "",
      CustodianEntityFileType: "",
      CustodianEntityAddress: "",
      CustodianEntityTAXId: "",
      CustodianEntityTaxDocument: "",
      CustodianEntityURL: "",
      CustodianEntityIntroducedBy: "",
      CustodianEntitySwift: "",
      CustodianEntityNotes: "",
      CustodianEntityPendingLimit: 0,
      CustodianEntityIsExchangeListed: false,
      CustodianEntityHasInvestmentGrade: false,
      CustodianEntityIsBank: false,
      LegalCustodianCode: "",
      CustodianEntityReference:"",
      countries: [],
      taxDocument: [],
      Contact: [],
      ClearingHouse: [],
      CodeType: []
    },
    custodianContact: {
      CustodianEntityContactName: "",
      CustodianEntityContactEmail1: "",
      CustodianEntityContactEmail2: "",
      CustodianEntityContactTel1: "",
      CustodianEntityContactTel2: "",
      CustodianEntityContactType: "",
      contactTypes: [],
      CustodianEntityContactNotes: "",
      CustodianEntityContactTicketConfirmation: false,
      CustodianEntityContactChangeType: ""
    },
    custodianClearingHouse: {
      CustodyClearingHouseCode: "",
      ClearingHouseId: "",
      clearingHouseName: "",
      clearingHouseNames: [],
      CustodyClearingHouseIsDefault: false,
      CustodyClearingHouseSettlementInstructions: "",
      CustodianEntityClearingHouseStatus: "",
      CustodianEntityClearingHouseCodeChange: "",
      CustodyClearingHouseChangeType: ""
    },
    custodianCodeType: {
      CodeTypeId: 0,
      CodeTypeValue: "",
      CodeTypeChangeType: ""
    },
    CodeTypeNames: [],
    loadingConfirmCustodianEntity: false,
    messageConfirmCustodianEntity: false,
    errors: {}
  };
}
